// extracted by mini-css-extract-plugin
export default {"title":"styles_title__TlKOs","classList":"styles_classList__VZt0Y","fade-in":"styles_fade-in__DugXL"};